function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 60.375l38.414 27.75a11.184 11.184 0 0013.172 0L105 60.375V22.5a7.5 7.5 0 00-7.5-7.5h-75a7.5 7.5 0 00-7.5 7.5v37.875zM37.5 37.5a3.75 3.75 0 013.75-3.75h37.5a3.75 3.75 0 013.75 3.75v3.75A3.75 3.75 0 0178.75 45h-37.5a3.75 3.75 0 01-3.75-3.75V37.5zm3.75 15a3.75 3.75 0 00-3.75 3.75V60a3.75 3.75 0 003.75 3.75h37.5A3.75 3.75 0 0082.5 60v-3.75a3.75 3.75 0 00-3.75-3.75h-37.5z",
  fill: "#ADC6CA"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M74.889 7.948C70.673 4.696 64.513-.058 60 .001c-4.513-.059-10.673 4.695-14.889 7.947-.863.667-1.645 1.27-2.314 1.756L35.625 15h48.75l-7.172-5.296a106.42 106.42 0 01-2.313-1.755h-.001zm3.861 25.803a3.75 3.75 0 013.75 3.75v3.75A3.75 3.75 0 0178.75 45h-37.5a3.75 3.75 0 01-3.75-3.75V37.5a3.75 3.75 0 013.75-3.75h37.5zm0 18.75a3.75 3.75 0 013.75 3.75V60a3.75 3.75 0 01-3.75 3.75h-37.5A3.75 3.75 0 0137.5 60v-3.75a3.75 3.75 0 013.75-3.75h37.5zM13.701 31.197L15 30.235v30.14L0 49.547V47.04a11.25 11.25 0 014.313-8.836c.626-.519 4.414-3.324 9.386-7.005l.002-.002zm101.987 7.007c-.68-.54-5.086-3.82-10.688-7.946v30.118l15-10.829V47.04a11.25 11.25 0 00-4.312-8.836zm-66.68 55.992A18.75 18.75 0 0060 97.758a18.75 18.75 0 0010.992-3.562L120 58.806v49.945c0 6.213-5.037 11.25-11.25 11.25h-97.5c-6.213 0-11.25-5.037-11.25-11.25V58.805l49.008 35.39z",
  fill: "#ADC6CA"
});

function SvgMailVerifyinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgMailVerifyinline;